export const isLatinCharacters = (str) => {
  return /[a-z]/i.test(str);
};
